import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import styled from '@emotion/styled';

import DataTable from './DataTable';

import {deleteAdminOrder, getAdminOrders, getResourceFile, updateAdminOrder} from '../../network';
import {formatDate, padding} from '../../utils/formatter';
import {formatPrice} from '../../helpers/Helper';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% - 14.75rem);
  height: 100vh;
  //height: 100%;

  padding: 1rem 1.5rem 0 1.5rem;
`;

const PageHeader = styled.h1`
  height: 1.25rem;
  font-size: 1.25rem;
  line-height: 1.25rem;

  font-family: OpticianSans, serif;
  font-style: normal;
  font-weight: normal;

  color: var(--color-gray-500);
`;

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: -webkit-fill-available;

  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;

  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;

  overflow-y: hidden;
`;

const Tag = styled.div`
  display: flex;
  width: fit-content;
  padding: var(--space-4) var(--space-6);

  font-size: var(--font-12);
  font-weight: 500;
  color: ${props => props.color ? `var(--color-${props.color}-800)` : ''};
  background-color: ${props => props.color ? `var(--color-${props.color}-100)` : ''};
  box-shadow: ${props => props.color ? `0 0 0 1px var(--color-${props.color}-300)` : '0 0 0 1px #C8E1D2'};
  border-radius: var(--space-4);
`;

const Label = styled.span`
  color: var(--color-gray-600);
  width: 6rem;
`;

const DetailHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: var(--space-24);
  margin-top: 1rem;
  margin-bottom: 2rem;
  > span {

    font-weight: 500;
    font-size: 1.125rem;
    line-height: 1.375rem;

    color: var(--color-gray-900);
  }
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: var(--space-24);
  margin-bottom: 1rem;
  > input[type=checkbox] {
    margin-left: 0;
    margin-right: var(--space-16);
  }
  //> span {
  //  font-size: var(--font-14);
  //  line-height: var(--font-14);
  //  font-weight: normal;
  //  font-style: normal;
  //
  //  color: var(--color-gray-900);
  //}
  > a {
    color: var(--company-dark);
    font-weight: 500;
    width: 12.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:last-of-type {
    margin-bottom: var(--space-28);
  }
`;

const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  justify-content: space-between;
  padding-top: var(--space-16);
  padding-left: var(--space-20);
  padding-right: var(--space-20);
  padding-bottom: var(--space-8);
  border-top: 1px solid var(--color-gray-300);
  > button {
    border: none;
    box-shadow: none;
    background: none;
    padding: var(--space-6) var(--space-8);
    border-radius: var(--space-4);
    color: var(--company-dark);
    font-size: var(--font-16);
    font-weight: normal;
    &:hover {
      background-color: var(--color-gray-200);
      transition: background-color 0.3s ease-in;
    }
    &:last-of-type {
      color: var(--color-red-700);
    }
  }
`;

const InnerDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: calc(100% - var(--space-32));
  line-height: 1.2;
  vertical-align: center;
  font-size: var(--font-14);

  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;

  overflow-y: hidden;

  background: white;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;

  padding: 0 1.5rem 0 1.5rem;

  justify-content: space-between;
  align-items: center;
`;

export const FilterSection = styled.div`
  display: flex;
  align-items: center;

  > span {
    height: 0.875rem;


    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
    color: var(--color-gray-600);
  }
`;

export const Dropdown = styled.div`
  border: 1px solid var(--color-gray-300);
  box-sizing: border-box;
  border-radius: 1.5rem;

  margin: 0 0 0 1rem;
  padding: 0 0.75rem 0 0.75rem;

  > select {
    height: 1.5rem;

    background: transparent;

    border: 0;

    appearance: none;
    outline: none;


    font-size: 0.75rem;
    font-weight: 500;

    color: var(--color-gray-800);
  }

  > img {
    margin-left: var(--space-8);
  }
`;

export const SearchSection = styled.div`
  display: flex;
  align-items: center;
  width: 30%;

  > img {
    position: relative;
    left: 90%;
  }

  > input {
    width: 100%;
    height: 1.875rem;

    padding: 1rem;
    background: white;

    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: 4px;

    color: var(--color-gray-500);

    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
  }
`;

const CellText = styled.span`
  width: 90%;


  font-style: normal;
  //font-weight: 500;
  font-size: 0.875rem;
  line-height: 1rem;

  color: var(--color-gray-900);

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Divider = styled.div`
  width: calc(100% - var(--space-48));
  margin-top: var(--space-8);
  margin-bottom: var(--space-24);
  margin-left: var(--space-24);
  height: 1px;
  background-color: var(--color-gray-300);
`;

const LineItemContainer = styled.div`
  display: flex;
  flex-direction: row;

  width: calc(100% - var(--space-48));
  margin-left: var(--space-24);
  margin-bottom: var(--space-40);
`;

// const ProductImageContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   position: relative;
//
//   width: var(--space-64);
//   height: var(--space-64);
//
//   background: white;
//
//   margin-bottom: var(--space-40);
//
//   border: 1px solid var(--color-gray-300);
//   box-sizing: border-box;
//   border-radius: var(--space-8);
//
//   > .badge {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     position: absolute;
//
//     width: auto;
//     height: var(--space-18);
//     min-width: var(--space-18);
//
//     font-size: var(--font-12);
//     line-height: var(--font-12);
//
//     background: white;
//     border: 1px solid var(--color-gray-500);
//     box-sizing: border-box;
//     box-shadow: none;
//
//     border-radius: 0.625rem;
//     left: 3.25rem;
//     top: 3.25rem;
//     margin: 0;
//   }
//
//   > img {
//     width: 90%;
//     height: 90%;
//     object-fit: contain;
//     padding: 0.25rem;
//   }
// `;

const ProductImageContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;

	width: var(--space-64);
    height: var(--space-64);

	background: white;

	/* margin-bottom: var(--space-40); */

	/* border: 1px solid var(--color-gray-300);
	box-sizing: border-box;
	border-radius: var(--space-8); */

	> .close {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;

		width: var(--space-24);
		height: var(--space-24);

		font-size: var(--font-12);
		line-height: var(--font-12);
		color: var(--color-gray-700);

		background: var(--color-gray-100);
		border: 1px solid var(--color-gray-600);
		box-sizing: border-box;

		border-radius: var(--space-20);
		left: 3.25rem;
        top: 3.25rem;

		cursor: pointer;
	}

	> .badge {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;

        width: auto;
        height: var(--space-18);
        min-width: var(--space-18);

        font-size: var(--font-12);
        line-height: var(--font-12);

        background: white;
        border: 1px solid var(--color-gray-500);
        box-sizing: border-box;
        box-shadow: none;

        border-radius: 0.625rem;
        left: 3.25rem;
        top: 3.25rem;
        margin: 0;
    }

	> div.image-container {
	    display: flex;
        align-items: center;
        justify-content: center;

		width: 100%;
		height: 100%;

		overflow: hidden;

		border: 1px solid var(--color-gray-300);
		box-sizing: border-box;
		border-radius: var(--space-8);

		> img {
			width: 100%;
			object-fit: cover;
		}

		> video {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
`;

const LineItemColumn = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 2rem;
`;

const LineItemTitle = styled.span`

  font-size: 0.875rem;
  line-height: 1rem;

  margin-bottom: 0.75rem;

  color: var(--color-gray-900);
`;

const LineItemPrice = styled.span`

  font-size: 0.875rem;
  line-height: 0.875rem;
  font-weight: 500;

  margin-bottom: 0.5rem;

  color: #049CBE;
`;

const LineItemQuantity = styled.span`

  font-size: 0.75rem;
  line-height: 0.75rem;
  font-weight: 500;

  color: var(--color-gray-600);
`;

const MasterContainer = styled.div`
  //height: -webkit-fill-available;
  height: calc(100vh - 2.5rem); // desperation
  flex-grow: 1;
  margin-right: 1.5rem;
`;

const DetailContainer = styled.div`
  width: 24rem;
  height: calc(100vh - 4.5rem); // desperation
`;

function BackOfficeOrders({auth}) {
    const [orders, setOrders] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [sort, setSort] = useState(null);
    const [filter, setFilter] = useState('');
    const [details, setDetails] = useState(null);
    const [detailsEdit, setDetailsEdit] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(25);
    const [pageCount, setPageCount] = useState(1);

    const adminToken = auth ? auth.token : null;

    const filters = [
        {
            value: 'new',
            text: 'Check Availability'
        },
        {
            value: 'processing',
            text: 'Processing'
        },
        {
            value: 'package_ready',
            text: 'Package Ready'
        },
        {
            value: 'customer_arrived',
            text: 'Customer Arrived'
        },
        {
            value: 'customer_paid',
            text: 'Customer Paid'
        },
        {
            value: 'cancelled',
            text: 'Cancelled'
        }
    ];
    const headers = [
        {
            title: 'Ticket No.',
            sortable: true,
            sort: 'ticket'
        }, {
            title: 'Status'
        }, {
            title: 'Customer'
        }, {
            title: 'Order Date',
            sortable: true,
            sort: 'created'
        }, {
            title: 'Items',
            center: true,
            sortable: true,
            sort: 'totalQuantity'
        }, {
            title: 'Total',
            sortable: true,
            sort: 'cartTotal'
        }
    ];


    useEffect(() => search(searchText),  [searchText, currentPage, sort, filter]);

    const search = searchText => {
        getAdminOrders(adminToken, searchText, currentPage, pageLimit, sort, filter ? {status: filter} : null)
            .then(result => {
                setDetails(null);
                setDetailsEdit(null);
                setOrders([...result.data]);
                setPageCount(Math.ceil(result.total / pageLimit));
            })
            .catch(error => console.error(error));
    };

    const removeOrder = id => {
        deleteAdminOrder(adminToken, id)
            .then(() => {
                setDetails(null);
                setDetailsEdit(null);
                search(searchText);
            })
            .catch(error => console.error(error));
    };

    const changeSort = sort => setSort(sort);

    const changePage = direction => {
        if (currentPage === 1 && direction < 0) return;
        if (currentPage === pageCount && direction > 0) return;

        setOrders([]);
        setCurrentPage(currentPage + (direction));
    };

    const processOrderStatus = status => {
        let result = {};
        if (status === 'new') result = {
            text: 'Check Availability',
            color: '#C05621',
            colorText: 'orange'
        };
        if (status === 'processing') result = {
            text: 'Processing',
            color: '#C05621',
            colorText: 'orange'
        };
        if (status === 'customer_arrived') result = {
            text: 'Customer Arrived',
            color: '#4299e1',
            colorText: 'blue'
        };
        if (status === 'package_ready') result = {
            text: 'Package Ready',
            color: '#4299e1',
            colorText: 'blue'
        };
        if (status === 'customer_paid') result = {
            text: 'Customer Paid',
            color: '#2F855A',
            colorText: 'green'
        };
        if (status === 'cancelled') result = {
            text: 'Cancelled',
            color: '#f56565',
            colorText: 'red'
        };

        return result;
    };

    const retrieveMedia = variant => {
        let src = null;
        if (variant.media && variant.media.length) {
            for (let i = 0; i < variant.media.length; i++) {
                if (variant.media[i].type === 'image') {
                    src = getResourceFile(variant.media[i].resource);
                    break;
                }
            }
        }

        if (!src) {
            if (variant.product_id.media && variant.product_id.media.length) {
                for (let i = 0; i < variant.product_id.media.length; i++) {
                    if (variant.product_id.media[i].type === 'image') {
                        src = getResourceFile(variant.product_id.media[i].resource);
                        break;
                    }
                }
            }
        }

        return src;
    };

    const onRowSelect = data => {
        const details = {
            _id: data._id,
            order_date: formatDate(data.created, 'MMM DD, YYYY'),
            ticket: padding(data.ticket, 8),
            total: formatPrice(data.cartTotal),
            item_count: data.variants.reduce((acc, val) => acc + val.quantity, 0),
            customer_name: `${data.customer.first_name} ${data.customer.last_name}`,
            variants: data.variants,
            has_insurance: data.has_insurance,
            status: data.status
        };
        setDetails(details);
        setDetailsEdit(null);
    };

    const dataRows = data => {
        let rows = [];
        data.map(item => {
            const status = processOrderStatus(item.status);
            rows.push({
                onRowSelect,
                data: item,
                view: <>
                    <CellText>{padding(item.ticket, 8)}</CellText>
                    <CellText style={{color: status.color}}>{status.text}</CellText>
                    <CellText style={{
                        color: '#049CBE',
                        cursor: 'pointer',
                        fontWeight: 500
                    }}>{item.customer.first_name} {item.customer.last_name}</CellText>
                    <CellText>{formatDate(item.created, 'DD/MM/YYYY')}</CellText>
                    <CellText style={{textAlign: 'center'}}>{item.variants.reduce((acc, val) => acc + val.quantity, 0)}</CellText>
                    <CellText>{formatPrice(item.cartTotal)}</CellText>
                </>
            });
        });
        return rows;
    };

    const handleEditChange = e => {
        const {value, name} = e.target;
        setDetailsEdit({
            ...detailsEdit,
            [name]: value
        });
    };

    const evalPrimaryAction = () => {
        if (!detailsEdit) setDetailsEdit({...details});
        else {
            // eval if valid information entered, collect updates and update customer
            updateAdminOrder(adminToken, detailsEdit._id, detailsEdit)
                .then(result => search(searchText))
                .catch(error => console.error(error));
        }
    };

    const evalSecondaryAction = () => {
        if (detailsEdit) setDetailsEdit(null);
        else removeOrder(details._id);
    };

    return (
        <Container>
            <MasterContainer>
                <PageHeader>ORDERS</PageHeader>
                <ContentContainer>
                    <Row style={{marginBottom: '1rem'}}>
                        <FilterSection>
                            <span>Filter by</span>

                            <Dropdown>
                                <select value={filter} onChange={e => setFilter(e.target.value)}>
                                    <option value=''>All</option>
                                    {
                                        filters.map((filter, index) => {
                                            return <option key={`BackofficeOrdersFilterOption_${index}`} value={filter.value}>{filter.text}</option>;
                                        })
                                    }
                                </select>
                                <img alt='dropdown' src='/icons/chevron.svg'/>
                            </Dropdown>
                        </FilterSection>

                        <SearchSection>
                            <img src='/icons/search.svg' alt='search icon'/>
                            <input placeholder='Search here...' type='text'/>
                        </SearchSection>
                    </Row>

                    <DataTable
                        headers={headers}
                        rows={dataRows(orders)}
                        changeSort={changeSort}
                        spacing={'15% 20% 20% 20% 10% 15%'}
                        currentPage={currentPage}
                        pageCount={pageCount}
                        pageBack={() => changePage(-1)}
                        pageNext={() => changePage(1)}
                    />
                </ContentContainer>
            </MasterContainer>

            {
                details && <DetailContainer>
                    <PageHeader>DETAILS</PageHeader>
                    <InnerDetailContainer>
                        <DetailHeader>
                            <span>Order {details.ticket}</span>
                        </DetailHeader>
                        <DetailRow>
                            <Label>Status:</Label>
                            {
                                detailsEdit ?
                                    <Dropdown style={{margin: '0'}}>
                                        <select name="status" value={detailsEdit.status} onChange={handleEditChange}>
                                            {
                                                filters.map((filter, index) => {
                                                    return <option key={`BackofficeOrdersEditStatusOption_${index}`} value={filter.value}>{filter.text}</option>;
                                                })
                                            }
                                        </select>
                                        <img alt='dropdown' src='/icons/chevron.svg'/>
                                    </Dropdown>
                                    : <Tag color={processOrderStatus(details.status).colorText}>{processOrderStatus(details.status).text}</Tag>
                            }
                        </DetailRow>
                        <DetailRow>
                            <Label>Order Date:</Label>
                            <span>{details.order_date}</span>
                        </DetailRow>
                        <DetailRow>
                            <Label>Order Total:</Label>
                            <span>{details.total} ({details.item_count} items)</span>
                        </DetailRow>
                        <DetailRow>
                            <Label>Customer:</Label>
                            <span>{details.customer_name}</span>
                        </DetailRow>
                        <DetailRow>
                            <input type="checkbox" checked={details.has_insurance} disabled/>
                            <label>Yes, I have Insurance</label>
                        </DetailRow>
                        <Divider/>
                        {
                            details.variants.map((variant, index) => {
                                const media = retrieveMedia(variant.variant);
                                return <LineItemContainer key={`OrderLineItemContainer_${index}`}>
                                    <ProductImageContainer>
                                        <div className="image-container">
                                            {media && <img src={media}/>}
                                        </div>
                                        <div className="badge">{variant.quantity}</div>
                                    </ProductImageContainer>

                                    {/*<ProductImageContainer>*/}
                                    {/*    {media && <img src={media}/>}*/}
                                    {/*    <div className="badge">{variant.quantity}</div>*/}
                                    {/*</ProductImageContainer>*/}

                                    <LineItemColumn>
                                        <LineItemTitle><b>{variant.variant.product.brand.name}</b>{` ${variant.variant.product.name}`}{`${variant.variant.description ? `, ${variant.variant.description}` : ''}`.trim()}
                                        </LineItemTitle>
                                        <LineItemPrice>{formatPrice(variant.total)}</LineItemPrice>
                                        <LineItemQuantity>Qty: {variant.quantity}</LineItemQuantity>
                                    </LineItemColumn>
                                </LineItemContainer>;
                            })
                        }
                        <ActionsBar>
                            <button onClick={evalPrimaryAction}>{detailsEdit ? 'Save Order' : 'Edit Order'}</button>
                            <button onClick={evalSecondaryAction}>{detailsEdit ? 'Cancel' : 'Delete'}</button>
                        </ActionsBar>
                    </InnerDetailContainer>
                </DetailContainer>
            }
        </Container>
    );
}

const mapStateToProps = state => ({
    auth: state.auth,
    user: state.user
});

export default connect(mapStateToProps, null)(BackOfficeOrders);
